import { render, staticRenderFns } from "./TestLoading.vue?vue&type=template&id=72bb9a06&scoped=true&"
import script from "./TestLoading.vue?vue&type=script&lang=js&"
export * from "./TestLoading.vue?vue&type=script&lang=js&"
import style0 from "./TestLoading.vue?vue&type=style&index=0&id=72bb9a06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bb9a06",
  null
  
)

export default component.exports